import {InputTextV2} from '@prtimes-basis/input';
import styles from './website-url-field.module.css';
import {
  FormField,
  useFormField,
} from '@/features/company-registration/steps/input-step/form-field';
import companyRegistrationPageStyles from '@/features/company-registration/styles.module.css';

export function WebsiteUrlField() {
  return (
    <FormField.Root name='companyInfo.websiteUrl'>
      <Body />

      <FormField.Error />

      <FormField.Description className={styles.description}>
        ホームページをお持ちでない場合、審査のために公的資料の提出などを
        ご依頼をさせていただくことがございます
      </FormField.Description>
    </FormField.Root>
  );
}

function Body() {
  const {fieldProps} = useFormField({
    hasDescription: true,
  });

  return (
    <InputTextV2
      wrapperClassName={companyRegistrationPageStyles.sizedInput}
      type='url'
      {...fieldProps}
    />
  );
}
